export default function pxToRem (number, base = 16) {
  if (base) {
    return (number / base) + 'rem'
  }
}
